const ESTIMATE_SELECTOR = '[data-mijota-delivery-estimate]';
const BUSINESS_DAY_MIN = 3;
const BUSINESS_DAY_MAX = 6;

function addBusinessDays(date, businessDays) {
  const estimate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  let remainingDays = businessDays;

  while (remainingDays > 0) {
    estimate.setDate(estimate.getDate() + 1);

    const day = estimate.getDay();
    if (day !== 0 && day !== 6) {
      remainingDays -= 1;
    }
  }

  return estimate;
}

function formatFrenchDate(date) {
  return new Intl.DateTimeFormat('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  }).format(date);
}

function getDeliveryEstimateText(date = new Date()) {
  const startDate = addBusinessDays(date, BUSINESS_DAY_MIN);
  const endDate = addBusinessDays(date, BUSINESS_DAY_MAX);

  return `Livraison estimée entre le ${formatFrenchDate(startDate)} et le ${formatFrenchDate(endDate)}.`;
}

function updateDeliveryEstimates(root = document) {
  const label = getDeliveryEstimateText();
  const estimates = root.querySelectorAll(ESTIMATE_SELECTOR);

  for (const estimate of estimates) {
    if (estimate.textContent.trim() !== label) {
      estimate.textContent = label;
    }
  }
}

let frame = 0;

function scheduleUpdate() {
  if (frame) return;

  frame = requestAnimationFrame(() => {
    frame = 0;
    updateDeliveryEstimates();
  });
}

const observer = new MutationObserver(scheduleUpdate);

function startDeliveryEstimate() {
  scheduleUpdate();

  if (!document.body) return;

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startDeliveryEstimate, { once: true });
} else {
  startDeliveryEstimate();
}
